export default __webpack_public_path__ + "static/media/Group 179.b36093ce.svg";